import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'card-totalizadores-component',
  templateUrl: 'card-totalizadores-component.html',
  styleUrls: ['./card-totalizadores-component.scss']
})

export class CardTotalizadoresComponent implements OnInit {

  @Output() onSelectItem = new EventEmitter();
  @Output() onSelectCard = new EventEmitter();

  @Input() tipo: string;
  @Input() classCSS: string;

  @Input() casosConfirmados: any;
  @Input() obitos: any;
  @Input() letalidade: any;
  @Input() selected: any;
  @Input() lista: any[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  selectCard(tipo) {
    this.onSelectCard.emit(tipo);
  }

  selectItem(item: any) {
    if ((this.tipo === 'INSUMOS') && (item && (item.titulo !== this.selected.titulo))) {
      this.onSelectItem.emit({
        card: item
      });
    }
  }

  formatNumber(num) {
    // console.log('num--------', typeof num)
    if (num) {
      num = num.toString().replace(',', '')
      num = num.toString().replace(',', '')
      let n = num;
      if (typeof num !== 'string') {
        n = n.toString();
      }
      let r = '';
      let x = 0;

      for (let i = n.length; i > 0; i--) {
        r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
        x = x === 2 ? 0 : x + 1;
      }
      return r.split('').reverse().join('');
    }
  }

}
